<template>
  <div id="relation-tags-menu">
    <div id="side-search-editor">
      <div id="main-categories-wrapper">
        <div>
          <div class="form-group search-input">
            <label>{{ $t("search") }}<span>({{tagSearchShortcut}})</span></label>
            <div class="form-control">
              <input type="text" id="main-search" class="input-ui"
                     ref="tagSearchInput"
                     v-model="searchQuery"
                     v-on:keyup="onSearchChange" />
              <span class="fa fa-search"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="side-editor">
      <div id="sub-categories-wrapper">
        <div id="side-tags">
          <app-load-content :loading="isTagsBusy">
            <div id="sub-categories" class="shortcuts right" v-if="displayTags">
              <div v-for="(tag, key) in displayTags" :key="key"
                   :class="{shortcut: true, [tag.category]: tag.category, pinned: tag.pinned,}"
                   :id="'shortcode-'+tag.key"
                   v-on:click="(e) => onRelationTagClick(e, tag)">

                <div :style="{background: tag.color}">{{ tag.key }}</div>{{ tag.name }}
              </div>
            </div>
          </app-load-content>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import _ from 'lodash';
  import { mapState, mapActions } from 'vuex';

  import LoadContent from '../load-content';

  import SHORTCUTS from '../../config/shortcut-keys';
  import editor from '../../helpers/editor';
  import FormHelper from '@/helpers/form';

  export default {
    props: {
      isTagsBusy: {
        type: Boolean,
        default: false
      },
      tag: {
        type: Object,
        required: true
      },
      relationTags: {
        type: Object,
        required: true
      },
      overflowPosition: {
        type: Object,
        required: true
      }
    },
    components: {
      'app-load-content': LoadContent
    },
    mounted() {
      if(this.relationTags) {
        this.displayTags = _.filter(this.relationTags, (tag => tag.key !== this.tag.key));
      }
      this.repositionTagsMenu();
    },
    watch: {
      "tags.relationshipData.data": {
        handler(newValue, oldValue){
          if(this.searchQuery) {
            if(Object.keys(newValue)?.length && !_.isEqual(newValue, oldValue)) this.displayTags = _.filter(newValue, (tag => tag.key !== this.tag.key));
          }
          else {
            this.displayTags = _.filter(this.relationTags, (tag => tag.key !== this.tag.key));
          }
        }
      }
    },
    computed: {
      ...mapState({
        projectSetupGeneral: state => state?.projectSetup?.projectSetup?.data?.general,
      }),
      ...mapState('tags', [
        'tags'
      ]),
      tagSearchShortcut () {
        return editor.getShortcutAsString(SHORTCUTS.shortcuts.search, '+');
      },
      projectId() {
        return this.$route.params.project_id;
      }
    },
    methods:{
      ...mapActions({
        'getRelationshipTags': 'tags/getRelationshipTags'
      }),
      delayFunction (callback, delayMs) {
        if(this.globalTimeout != null)
          clearTimeout(this.globalTimeout);

        this.globalTimeout = setTimeout(callback, delayMs);
      },
      onSearchChange() {
        FormHelper.delayFunction(() => this.queryTags(), 500, this);
      },
      queryTags () {
        this.globalTimeout = null;

        if(!this.tags.relationshipIsBusy) {
          this.getRelationshipTags({
            projectId: this.projectId,
            searchQuery: this.searchQuery
          });
        }
      },
      onRelationTagClick (e, tag) {
        this.$emit('recordAction', tag);
        this.$emit('addRelationMentionTag', this.tag, tag);
        this.$emit('closeRelationTagMenu');
      },
      repositionTagsMenu () {
        const tagsMenu = this.$el;
        const overflow = this.overflowPosition;

        const clickX = overflow.xCoordinate, clickY = overflow.yCoordinate;
        const w = window.innerWidth, h = window.innerHeight;
        const menuWidth = tagsMenu.offsetWidth, menuHeight = tagsMenu.offsetHeight;

        if (clickX+ 5 + menuWidth > w)
          tagsMenu.style.right = "0";
        else
          tagsMenu.style.left = (clickX + 5) + "px";

        if (clickY - 5 + menuHeight > h)
          tagsMenu.style.bottom = "5px";
        else
          tagsMenu.style.top = clickY - 5 + "px";
      }
    },
    data () {
      return {
        globalTimeout: null,
        displayTags: {},
        searchQuery: ''
      }
    }
  }
</script>